import React, { useEffect, useState } from 'react';
import { Box, Text } from '@mantine/core';
import { useLocation, useNavigate } from 'react-router-dom';
import Module from '../components/Module';
import EmplacementsControlAlert from '../components/emplacements/EmplacementsControlAlert';
import { useDynamicImport } from '../hooks/useDynamicImport';
import { authFetch, parseJsonResponse } from '../lib/api';

const DASHBOARD_META = {
  component_path: './pages/Dashboard',
  module_title: 'Tableau de bord',
  module_subtitle: "Vue d'ensemble de l'archivage",
  icon: 'IconLayoutDashboard',
};

export default function AppMain({ user, onUserUpdate }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [menuMeta, setMenuMeta] = useState(
    !location.pathname || location.pathname === '/' ? DASHBOARD_META : null,
  );
  const [checkingAccess, setCheckingAccess] = useState(false);

  useEffect(() => {
    const path = location.pathname;

    if (!path || path === '/') {
      setMenuMeta(DASHBOARD_META);
      return;
    }

    setCheckingAccess(true);
    setMenuMeta(null);
    authFetch(`/api/menu_items/by-route?path=${encodeURIComponent(path)}`)
      .then((r) => parseJsonResponse(r))
      .then((d) => {
        if (d.success) {
          setMenuMeta(d.data);
          return;
        }
        // Page du compte précédent (ex. Utilisateurs) : renvoyer au tableau de bord
        navigate('/', { replace: true });
      })
      .catch(() => {
        navigate('/', { replace: true });
      })
      .finally(() => setCheckingAccess(false));
  }, [location.pathname, navigate]);

  const { component: PageComponent, icon: PageIcon, loading, error } = useDynamicImport(
    menuMeta?.component_path,
    menuMeta?.icon
  );

  if (!menuMeta) {
    return (
      <Module title={checkingAccess ? 'Chargement' : 'Page introuvable'} subtitle="">
        <Text c="dimmed">
          {checkingAccess
            ? 'Vérification des droits…'
            : 'Cette route n&apos;existe pas ou vous n&apos;y avez pas accès.'}
        </Text>
      </Module>
    );
  }

  return (
    <Box style={{ flex: 1, minHeight: 0, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
      <Module
        title={menuMeta.module_title || menuMeta.label}
        subtitle={menuMeta.module_subtitle || ''}
        icon={PageIcon}
        titleExtra={
          location.pathname.startsWith('/emplacements') &&
          location.pathname !== '/emplacements/visu-graphique'
            ? <EmplacementsControlAlert />
            : null
        }
      >
        {loading && <Text>Chargement…</Text>}
        {error && <Text c="red">{error}</Text>}
        {!loading && !error && PageComponent && (
          <PageComponent user={user} onUserUpdate={onUserUpdate} />
        )}
      </Module>
    </Box>
  );
}
